import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/bt4mlogo.png';
import { FaPhoneAlt } from 'react-icons/fa';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="w-full z-50 bg-white text-gray-900 shadow-sm border-b border-gray-100">
      <div className="flex items-center justify-between px-6 py-4 max-w-7xl mx-auto">

        {/* Logo */}
        {/* <div className="flex items-center"> */}
          {/* <Link
            to="/"
            className="ml-2 text-lg md:text-2xl font-bold tracking-wide hover:text-teal-600 transition-colors duration-200"
          > */}
          <a href="/">
         <img
        src={logo}
        alt="BookTrip4Me Logo"
        className="h-14 w-18 md:h-16 md:w-22"
      />
      </a>

          
           
          {/* </Link> */}
        {/* </div> */}

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8 text-md font-medium">
          <NavItem to="/flights" label="Flights" />
          <NavItem to="/carRentals" label="Car Rentals" />
          <NavItem to="/cruise" label="Cruise" />
          <NavItem to="/policy" label="Policy" />
        </nav>

        {/* Call Button (Mint Theme) */}
        <a
          href="tel:+18887112909"
          className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-semibold px-3 py-2 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 text-xs md:text-base"
        >
          <FaPhoneAlt className="text-md md:text-xl" />
          <span className="block md:hidden text-xs" style={{ fontSize: "14px" }}>
            +1 888-711-2909
          </span>
          <span className="hidden md:block">Call Now: +1 888-711-2909</span>
        </a>

        {/* Mobile Menu Button */}
        <div
          className="md:hidden flex flex-col ml-4 cursor-pointer"
          onClick={toggleMenu}
        >
          <span className="h-1 w-6 bg-gray-700 my-1 rounded-md"></span>
          <span className="h-1 w-6 bg-gray-700 my-1 rounded-md"></span>
          <span className="h-1 w-6 bg-gray-700 my-1 rounded-md"></span>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white text-gray-900 px-6 py-4 space-y-3 font-medium border-t border-gray-200 shadow-sm">
          <Link to="/flights" className="block hover:text-teal-600">Flights</Link>
          <Link to="/carRentals" className="block hover:text-teal-600">Car Rentals</Link>
          <Link to="/cruise" className="block hover:text-teal-600">Cruise</Link>
          <Link to="/policy" className="block hover:text-teal-600">Policy</Link>
        </div>
      )}
    </header>
  );
}

function NavItem({ to, label }) {
  return (
    <Link
      to={to}
      className="hover:text-teal-600 transition duration-200 border-b-2 border-transparent hover:border-teal-600"
    >
      {label}
    </Link>
  );
}

export default Header;
